import { TableUIProvider } from "../../../contexts/TableUIContext";
import LessonTypes from "./LessonTypes";

export default function LessonTypesWrapper() {
    return (
        <TableUIProvider>
            <LessonTypes />
        </TableUIProvider>
    );
}
